module.exports = __webpack_public_path__ + "static/media/u12_4.52736010.mp3";